import Highlights from '../src/Highlights/index';
export default Highlights;
